const FILTER_KEYS = ['jobSearch', 'jobLocation', 'jobType', 'jobOrg', 'jobPage'];

function resultsHost(block) {
    return block.querySelector('[js-sector-jobs-results]');
}

function currentFilters(block) {
    const form = block.querySelector('#search-form');
    const params = new URLSearchParams();

    if (form) {
        const search = form.querySelector('[name="jobSearch"]');
        const location = form.querySelector('[name="jobLocation"]');
        const type = form.querySelector('[name="jobType"]');
        const org = form.querySelector('[name="jobOrg"]');

        if (search && search.value.trim()) params.set('jobSearch', search.value.trim());
        if (location && location.value) params.set('jobLocation', location.value);
        if (type && type.value) params.set('jobType', type.value);
        if (org && org.value) params.set('jobOrg', org.value);
    }

    return params;
}

function filtersFromHref(href) {
    const url = new URL(href, window.location.origin);
    const params = new URLSearchParams();

    FILTER_KEYS.forEach(function (key) {
        const value = url.searchParams.get(key);
        if (value) params.set(key, value);
    });

    return params;
}

function pageUrl(params) {
    const query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
}

function load(block, params, options) {
    const host = resultsHost(block);
    if (!host) return;

    const settings = options || {};
    const endpoint = block.getAttribute('data-endpoint');
    const request = new URLSearchParams(params.toString());

    request.set('containerKey', block.getAttribute('data-container-key') || '');
    request.set('pageSize', block.getAttribute('data-page-size') || '');
    request.set('anchorId', block.getAttribute('data-anchor') || '');
    request.set('path', window.location.pathname);

    const searchInput = block.querySelector('[name="jobSearch"]');
    const keepFocus = !!searchInput && document.activeElement === searchInput;

    host.setAttribute('aria-busy', 'true');
    block.classList.add('is-loading');

    fetch(endpoint + '?' + request.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
    })
        .then(function (response) {
            if (!response.ok) throw new Error('Request failed: ' + response.status);
            return response.text();
        })
        .then(function (html) {
            host.innerHTML = html;

            if (settings.push !== false) {
                window.history.pushState({ sectorJobs: true }, '', pageUrl(params));
            }

            if (keepFocus) {
                const input = block.querySelector('[name="jobSearch"]');
                if (input) {
                    input.focus();
                    input.setSelectionRange(input.value.length, input.value.length);
                }
            } else if (settings.scroll) {
                block.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        })
        .catch(function () {
            window.location.href = pageUrl(params) + '#' + (block.getAttribute('data-anchor') || '');
        })
        .then(function () {
            host.removeAttribute('aria-busy');
            block.classList.remove('is-loading');
        });
}

function bind(block) {
    block.addEventListener('submit', function (event) {
        if (!event.target.closest('#search-form')) return;
        event.preventDefault();
        load(block, currentFilters(block));
    });

    block.addEventListener('change', function (event) {
        if (!event.target.matches('[name="jobLocation"], [name="jobType"], [name="jobOrg"]')) return;
        load(block, currentFilters(block));
    });

    block.addEventListener('click', function (event) {
        const link = event.target.closest('.pagination a.page-link, #search-cancel-btn, [data-sector-jobs-clear]');
        if (!link) return;

        const item = link.closest('.page-item');
        if (item && (item.classList.contains('disabled') || item.classList.contains('current'))) {
            event.preventDefault();
            return;
        }

        event.preventDefault();
        load(block, filtersFromHref(link.getAttribute('href')), { scroll: true });
    });
}

function init() {
    const blocks = document.querySelectorAll('[data-sector-jobs]');
    if (!blocks.length) return;

    blocks.forEach(bind);

    window.addEventListener('popstate', function () {
        const params = new URLSearchParams(window.location.search);
        const filters = new URLSearchParams();

        FILTER_KEYS.forEach(function (key) {
            const value = params.get(key);
            if (value) filters.set(key, value);
        });

        blocks.forEach(function (block) {
            load(block, filters, { push: false });
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
